import { USER_TEAM_ROLE } from "@tastyworks/shared-utils/misc/constants"
import { RestResource } from "./common"
import { SchemaDeSerBuilder } from "./deser"

export class UserTeam extends RestResource {
  name = ""
  users: UserTeamMember[] = []
}

export class UserTeamMember extends RestResource {
  role: `${USER_TEAM_ROLE}` = USER_TEAM_ROLE.MEMBER
  email = ""
  teamId = ""
  name = ""
  invitationAccepted = false
}

export const USER_TEAM_MEMBER_DESER = new SchemaDeSerBuilder<UserTeamMember>(
  UserTeamMember
)
  .ofString("id")
  .ofString("role")
  .ofString("email")
  .ofString("teamId")
  .ofString("name")
  .ofBoolean("invitationAccepted")
  .toDeSer()

export const USER_TEAMS_DESER = new SchemaDeSerBuilder<UserTeam>(UserTeam)
  .ofString("id")
  .ofString("name")
  .ofArray("users", USER_TEAM_MEMBER_DESER, UserTeamMember, "user-teams-users")
  .toDeSer()
